import React, { useEffect } from "react";
import "@/App.css";
import "./i18n"; // Import i18n configuration
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "./context/ThemeContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/HomeOption1";
import Events from "./pages/Events";
import Association from "./pages/Association";
import Venir from "./pages/Venir";
import Actualites from "./pages/Actualites";
import Benevoles from "./pages/Benevoles";
import Partenaires from "./pages/Partenaires";
import Contact from "./pages/Contact";
import Adhesion from "./pages/Adhesion";
import Admin from "./pages/Admin";
import PortailAdherent from "./pages/PortailAdherent";
import MentionsLegales from "./pages/MentionsLegales";
import Tombola from "./pages/Tombola";
import Endurance from "./pages/Endurance";
import EventOrganization from "./pages/EventOrganization";
import InfosPratiques from "./pages/InfosPratiques";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <ThemeProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/evenements" element={<Events />} />
              <Route path="/association" element={<Association />} />
              <Route path="/venir" element={<Venir />} />
              <Route path="/actualites" element={<Actualites />} />
              <Route path="/endurance" element={<Endurance />} />
              <Route path="/evenement/:eventId/organisation" element={<EventOrganization />} />
              <Route path="/infos-pratiques" element={<InfosPratiques />} />
              <Route path="/benevoles" element={<Benevoles />} />
              <Route path="/partenaires" element={<Partenaires />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/adhesion" element={<Adhesion />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/portail-adherent" element={<PortailAdherent />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/tombola" element={<Tombola />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
        <Toaster 
          position="top-right"
          toastOptions={{
            style: {
              background: 'hsl(var(--card))',
              color: 'hsl(var(--card-foreground))',
              border: '1px solid hsl(var(--border))',
            },
          }}
        />
      </div>
    </ThemeProvider>
  );
}

export default App;
